import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/** Earliest day first by default, like the old holiday list's `{ StartDateUTC: 1 }` sort. */
export const DEFAULT_HOLIDAYS_ORDER: OrderBy[] = [{ field: 'StartDate', direction: 'ASC' }];

export const buildGetHolidaysQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_HOLIDAYS_ORDER
) => `
  query {
    Holidays: getHolidays(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        Name
        StartDate
        IsRegional
        CantonIds
      }
    }
  }
`;
